import styled from 'styled-components'

export const Container = styled.main`
  width: fit-content;
  padding: 2%;
  margin: 0 auto;

  @media (max-width: 766px) {
    width: 100%;
  }
`

export const Inner = styled.div`
  display: flex;
  gap: 1rem;

  .doc,
  .doc > label {
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }

  > :last-child > h4 {
    font-size: 1.25rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid;
  }

  > div {
    border-radius: 0.5rem;
  }

  > :first-child {
    width: 100%;
    max-width: 58.75rem;
  }

  > :last-child {
    background: ${({ theme }) => theme.colors.black};
    padding: 1.25rem;
    height: fit-content;
    width: fit-content;
    > div {
      max-height: 66rem;
      overflow-y: auto;
      overflow-x: hidden;
      width: 105%;
    }
  }

  @media (max-width: 766px) {
    flex-direction: column-reverse;
    > :last-child {
      width: 100%;
      > div {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(11.25rem, 1fr));
        gap: 1rem;
        max-height: 60vh;
        width: 100%;
      }
    }
  }
`
export const Table = styled.div`
  position: relative;

  h4,
  .price {
    font-size: 0.875rem;
    font-weight: 500;
  }

  img {
    width: 6.25rem;
    height: 6.25rem;
  }
  > span {
    display: flex;
    gap: 0.375rem;
    margin-bottom: 1rem;
  }
`
